import React, { useState } from 'react';
import './FilterDropdown.css';

const FilterDropdown = ({ 
  selectedChannels, 
  onChannelToggle,
  showRaidFinder,
  onToggleRaidFinder,
  autoScrollPaused,
  onToggleAutoScroll
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const channelOptions = [
    { id: 2, name: 'Trade' },
    { id: 6, name: 'Nation' },
    { id: 18, name: 'Global' }
  ];

  const handleChannelToggle = (channelId) => {
    onChannelToggle(channelId);
  };

  return (
    <div className="filter-controls">
      <div className="filter-dropdown">
        <button 
          className="filter-button"
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          🔧 Channel Filters
        </button>
        
        {isOpen && (
          <div 
            className="filter-menu"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
          >
            <div className="filter-section">
              <h4>Channels</h4>
              {channelOptions.map(channel => (
                <label key={channel.id} className="filter-option">
                  <input
                    type="checkbox"
                    checked={selectedChannels.includes(channel.id)}
                    onChange={() => handleChannelToggle(channel.id)}
                  />
                  <span>{channel.name}</span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
      
      <button 
        className={`raid-finder-toggle ${showRaidFinder ? 'active' : ''}`}
        onClick={onToggleRaidFinder}
        title={showRaidFinder ? 'Hide Raid Finder' : 'Show Raid Finder'}
      >
        {showRaidFinder ? '⚔️' : '⚔️'}
        <span className="toggle-text">{showRaidFinder ? 'Hide Raids' : 'Show Raids'}</span>
      </button>
      
      <button 
        className="raid-finder-toggle"
        onClick={onToggleAutoScroll}
        title={autoScrollPaused ? 'Resume Auto-Scroll' : 'Pause Auto-Scroll'}
      >
        {autoScrollPaused ? '' : ''}
        <span className="toggle-text">{autoScrollPaused ? 'Resume Auto-Scroll' : 'Pause Auto-Scroll'}</span>
      </button>
    </div>
  );
};

export default FilterDropdown;
